import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface KeyHostAuthorizationChangeFilters {
  key_id?: string;
  store_id?: string;
  changed_by_type?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetKeyHostAuthorizationChanges = (
  filters: KeyHostAuthorizationChangeFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.KEY_HOST_AUTHORIZATION_CHANGES, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
